<template>
    <div class="cs-template-picker">
        <div class="cs-modal-header">
            <h3>Choose a Template</h3>
            <button class="cs-close-btn" @click="$emit('close')">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
            </button>
        </div>

        <div class="cs-template-grid">
            <div
                v-for="tmpl in templates"
                :key="tmpl.id"
                class="cs-template-card"
                @click="$emit('select', tmpl)"
            >
                <div class="cs-tmpl-icon" :class="'cs-cat-' + tmpl.category">
                    <svg v-if="tmpl.category === 'trend'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                    </svg>
                    <svg v-else-if="tmpl.category === 'oscillator'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                    </svg>
                    <svg v-else-if="tmpl.category === 'volatility'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M2 20h.01"/><path d="M7 20v-4"/><path d="M12 20v-8"/>
                        <path d="M17 20V8"/><path d="M22 4v16"/>
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M12 20V10"/><path d="M18 20V4"/><path d="M6 20v-4"/>
                    </svg>
                </div>
                <div class="cs-tmpl-info">
                    <div class="cs-tmpl-name">{{ tmpl.name }}</div>
                    <div class="cs-tmpl-desc">{{ tmpl.description }}</div>
                    <div class="cs-tmpl-meta">
                        <span class="cs-tmpl-badge" :class="'cs-badge-' + tmpl.category">{{ tmpl.category }}</span>
                        <span class="cs-tmpl-side">{{ tmpl.side === 'onchart' ? 'Overlay' : 'Pane' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { TEMPLATE_LIST } from '../../candle-script/templates/index.js';

export default {
    name: 'TemplatePicker',
    data() {
        return {
            templates: TEMPLATE_LIST,
        };
    },
};
</script>

<style scoped>
.cs-template-picker {
    background: var(--tc-bg-elevated, #fff);
    border-radius: 12px;
    box-shadow: var(--tc-shadow-lg, 0 8px 30px rgba(0,0,0,0.12));
    width: 560px;
    max-height: 80vh;
    overflow-y: auto;
}

.cs-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--tc-border-primary, #e0e3eb);
}

.cs-modal-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--tc-text-primary, #131722);
}

.cs-close-btn {
    background: none;
    border: none;
    color: var(--tc-text-secondary, #787b86);
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
}
.cs-close-btn:hover {
    background: var(--tc-bg-hover, rgba(0,0,0,0.04));
}

.cs-template-grid {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.cs-template-card {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    padding: 14px;
    border: 1px solid var(--tc-border-primary, #e0e3eb);
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.15s;
}
.cs-template-card:hover {
    border-color: var(--tc-accent, #2962ff);
    background: var(--tc-accent-bg, rgba(41,98,255,0.04));
}

.cs-tmpl-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.cs-cat-trend { background: rgba(41,98,255,0.1); color: #2962ff; }
.cs-cat-oscillator { background: rgba(126,87,194,0.1); color: #7e57c2; }
.cs-cat-volatility { background: rgba(255,109,0,0.1); color: #ff6d00; }
.cs-cat-custom { background: rgba(38,166,154,0.1); color: #26a69a; }

.cs-tmpl-info {
    flex: 1;
}

.cs-tmpl-name {
    font-size: 14px;
    font-weight: 600;
    color: var(--tc-text-primary, #131722);
    margin-bottom: 4px;
}

.cs-tmpl-desc {
    font-size: 12px;
    color: var(--tc-text-secondary, #787b86);
    margin-bottom: 8px;
}

.cs-tmpl-meta {
    display: flex;
    align-items: center;
    gap: 8px;
}

.cs-tmpl-badge {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 2px 8px;
    border-radius: 4px;
}
.cs-badge-trend { background: rgba(41,98,255,0.1); color: #2962ff; }
.cs-badge-oscillator { background: rgba(126,87,194,0.1); color: #7e57c2; }
.cs-badge-volatility { background: rgba(255,109,0,0.1); color: #ff6d00; }
.cs-badge-custom { background: rgba(38,166,154,0.1); color: #26a69a; }

.cs-tmpl-side {
    font-size: 10px;
    color: var(--tc-text-tertiary, #9ca3af);
}
</style>
